interface QuickStreamArguments {
  supplierBusinessCode: string;
  inputStyleOverrides?: QuickstreamAPI.StyleMap;
}

export const getQuickstreamOptions = ({
  supplierBusinessCode,
  inputStyleOverrides,
}: QuickStreamArguments) => {
  const inputStyle: QuickstreamAPI.StyleObject = {
    style: {
      "box-sizing": "border-box",
      width: "100%",
      height: "48px",
      border: "0",
      "border-radius": "0",
      "border-bottom": "4px solid transparent",
      margin: "0",
      "padding-top": "0",
      "padding-bottom": "0",
      "background-color": "#f2f2f2",
      "padding-left": "16px",
      "padding-right": "16px",
      "font-size": "16px",
      "font-weight": "300",
      "line-height": "24px",
      "font-family": "'Roboto',sans-serif",
      color: "#000000",
      appearance: "none",
      ...inputStyleOverrides,
    },
  };

  const options: QuickstreamAPI.creditCards.Options = {
    config: {
      supplierBusinessCode,
    },
    showAcceptedCards: false,
    iframe: {
      width: "100%",
      height: "100%",
      style: {
        "font-family": '"Roboto", sans-serif',
        "font-size": "16px",
      },
    },
    body: {
      style: {
        "font-family": '"Roboto", sans-serif',
        "font-size": "16px",
      },
    },
    labels: {
      style: {
        display: "inline-block",
        "font-weight": "400",
        "margin-bottom": "8px",
        "font-family": '"Roboto", sans-serif',
        color: "#414141",
        "font-size": "1rem",
        "line-height": "24px",
      },
    },
    cardholderName: {
      ...inputStyle,
      label: "Name on card",
    },
    cardNumber: {
      ...inputStyle,
      label: "Card number",
    },
    expiryDateMonth: {
      ...inputStyle,
    },
    expiryDateYear: {
      ...inputStyle,
    },
    cvn: {
      ...inputStyle,
      label: "Security code",
    },
  };

  return options;
};
